import { Component } from "@angular/core";
import { Globals } from "projects/shared/models/Globals";
import { AppService } from "../../services/app.service";
import {
  MarkerTypeId,
  IMapOptions,
  IBox,
  IMarkerIconInfo,
  MapTypeId
} from "angular-maps";
import {} from "node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.All";
import { IClusterIconInfo } from "angular-maps/src/interfaces/icluster-icon-info";

import { GenericResponseContract } from "projects/shared/models/GenericResponseContract";
import { GenericListContract } from "projects/shared/models/GenericListContract";
import { EgyptianTreasureListItemContract } from "../../models/EgyptianTreasureListItemContract";
import { MapsFiltrationContract } from "../../models/MapsFiltrationContract";

let PathData: Array<any> = null;
declare var $ :any;
declare var parentId:any;

@Component({
  selector: "inner-map-root",
  templateUrl: "./inner-map-root.component.html",
  styles: []
})
export class InnerMapRootComponent {
  PinInfo:any;
  input = new MapsFiltrationContract();
  globals;
  _markerTypeId = MarkerTypeId;

  _options: IMapOptions = {
    mapTypeId: MapTypeId.aerial,
    showCopyright: false,
    showMapTypeSelector: false, //hides map controls
    showDashboard: true, //hides map controls
    disableBirdseye: true,
    
    //showLocateMeButton:false, //custom added
    //minZoom:3, //custom added

    // customMapStyle:{
    //   "elements": {
    //     "political": { "borderStrokeColor": "rgba(0, 0,0,0)", "borderOutlineColor": "rgba(0, 0, 0,0)" },
    //     "transportation": { "strokeColor": "rgba(0, 0,0,0)" },
    //   },
    //   "version": "1.0"
    // } //custom added after using map type aerial instead of hybred it is now obsolete

    };

  //initially egypt boundries
  _box: IBox = {
    maxLatitude: 32.385195,
    maxLongitude: 44.468716,

    minLatitude: 19.379187,
    minLongitude: 14.695767
  };

  _iconInfo: IMarkerIconInfo = {
    markerType: MarkerTypeId.ScaledImageMarker,
    url: '/Style Library/images/flag.png',
    scale: .08,
    markerOffsetRatio: { x: 0.15, y: 0.15 }
  };
  
  _ranges: Map<number, string> = new Map<number, string>([
    [10, "rgba(20, 180, 20, 0.5)"],
    [20, "rgba(255, 210, 40, 0.5)"],
    [Number.MAX_SAFE_INTEGER, "rgba(255, 40, 40, 0.5)"]
  ]);

  _mapPins: Array<EgyptianTreasureListItemContract> = new Array<
    EgyptianTreasureListItemContract
  >();

   constructor(private apiService: AppService) {}

  ngOnInit() {
    this.globals=Globals;
    this.GetFilteredMapItems();
  }

  GetFilteredMapItems() {
    this.input.citiesIds=null;
    this.input.dynastiesIds=null;
    this.input.periodId=parentId;
    this.apiService
      .getFilteredMapItems(this.input)
      .subscribe(
        (
          response: GenericResponseContract<
            GenericListContract<EgyptianTreasureListItemContract>
          >
        ) => {
          this._mapPins = response.Data.ListItems;
          // this._box.maxLatitude=Math.max.apply(Math, this._mapPins.map(function(o) { return o.Latitude; }));
          // this._box.minLatitude=Math.min.apply(Math, this._mapPins.map(function(o) { return o.Latitude; }));
          // this._box.maxLongitude=Math.max.apply(Math, this._mapPins.map(function(o) { return o.Longitude; }));
          // this._box.minLongitude=Math.min.apply(Math, this._mapPins.map(function(o) { return o.Longitude; }));
          
          
          console.log(response);
        }
      );
  }

  _openPopup($event){
    $("#myModal").modal()
    this.PinInfo=$event;
    this.apiService.getEgyptianTreasureItemDetails($event.Id).subscribe((response:  GenericResponseContract<object>) => {
      Object.assign(this.PinInfo,response.Data);
  }); 
  }

}
